import useAllSourceMappings from 'components/Mappings/_helpers/useAllSourceMappings';
import {
  ORG_TEAM_LEADER_MAPPING_REF_KEY,
  ORG_TEAM_LEADER_MAPPING_MATCH_KEY,
} from 'pages/Directory/consts';

function useExistingOrgMappingsInfo(
  directory: any,
  sourceId: string,
): {
  orgMappingsSet: boolean;
  orgMappedToSourceName: string;
  orgMappedToSourceId: string;
} {
  const allSourceMappings = useAllSourceMappings({ directory, sourceId: sourceId })[0] || [];
  const tlRefMapping = allSourceMappings.find(
    (m: any) => m.destination === ORG_TEAM_LEADER_MAPPING_REF_KEY,
  );
  const tlMatchMapping = allSourceMappings.find(
    (m: any) => m.destination === ORG_TEAM_LEADER_MAPPING_MATCH_KEY,
  );
  const orgMappingsSet = allSourceMappings && Boolean(tlRefMapping) && Boolean(tlMatchMapping);
  const orgMappedToSourceName = orgMappingsSet && tlMatchMapping.fromSource;
  const orgMappedToSourceId = orgMappingsSet && tlMatchMapping.sourceId;

  return {
    orgMappingsSet,
    orgMappedToSourceName,
    orgMappedToSourceId,
  };
}

export default useExistingOrgMappingsInfo;
